/* global angular, $ */
angular.module('ua5App')
    .directive('resourceGrid', ['$sce', '$rootScope', '$timeout', function($sce, $rootScope, $timeout) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-grid/resource-grid.html',
            scope: {
                gridStyle: '@',
                content: '=',
                contentTitle: '@',
                hideTitle: '@',
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {
                $scope.sortByRank = function(item) {
                    return parseInt(item.rank, 10);
                };

                // content should be an array of objects with {subtitle, body}
                for (var i = 0; i < $scope.content; i++) {
                    for (var j = 0; j < $scope.content[i].items.length; j++) {

                        $scope.content[i].items[j].title = $sce.trustAsHtml($scope.content[i].items[j].title);
                        $scope.content[i].items[j].subtitle = $sce.trustAsHtml($scope.content[i].items[j].subtitle);
                        $scope.content[i].items[j].body = $sce.trustAsHtml($scope.content[i].items[j].body);
                    }
                }

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});

                    // init collapsible sections
                    $('.resource-grid__subsection__collapse-btn', element).each(function() {
                        $(this).click(function() {
                            $(this).attr('data-open', $(this).attr('data-open') === 'false' ? true : false);
                            $(this).next('.resource-grid__subsection__collapse-section').slideToggle();
                        });

                        if ($(this).attr('data-open') === 'false') {
                            $(this).click();
                        }
                    });

                    // init collapsible sections
                    $('.resource-grid__section__collapse-btn', element).each(function() {
                        $(this).click(function() {
                            var isClosed = $(this).attr('data-open') === 'false' ;
                            if (isClosed) {
                                $(this).prev('.resource-grid--person__section__subtitle').addClass('collapsed');
                                $(this).attr('data-open', true);
                                $(this).next('.resource-grid__section__collapse-section').slideUp();
                            } else {
                                $(this).prev('.resource-grid--person__section__subtitle').removeClass('collapsed');
                                $(this).attr('data-open', false);
                                $(this).next('.resource-grid__section__collapse-section').slideDown();
                            }
                        });

                        if ($(this).attr('data-open') === 'false') {
                            $(this).click();
                        }
                    });

                    $('.resource-grid__section__collapse-title, .resource-grid__subsection__collapse-title', element).click(function() {
                        $(this).next().click();
                    });
                });
            }
        };
    }])
;
